import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Modal, NavLink } from "react-bootstrap";

const ButtonModalPlaceholder = ({ btnTitle, btnDescription, btnIcon, modalTitle, modalIcon, placeholderData, modalClassName }) => {
    const [placeholderModalShow, setPlaceholderModalShow] = useState(false);
    return (placeholderData) &&
        <>
            <NavLink onClick={() => setPlaceholderModalShow(true)} style={{ textDecoration: "none" }} className="status-wifi">
                <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
                    <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
                        <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <FontAwesomeIcon icon={btnIcon} color="#FFF" style={{ fontSize: 14 }} />
                        </div>
                        <div className="text-left">
                            <p className="mb-0">
                                <b style={{ color: "#555555" }}>{btnTitle}</b>
                            </p>
                            <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                                {btnDescription}
                            </p>
                        </div>
                    </div>
                </div>
            </NavLink>
            <Modal
                show={placeholderModalShow}
                onHide={() => setPlaceholderModalShow(false)}
                className={"info-modal "+modalClassName}
                style={{ height: 260 }}
            >
                <div className="modal-content-custom">
                    <Modal.Body className="modal-body-custom">
                        <div className="text-center p-4 mb-4 flex">
                            <div>
                                <FontAwesomeIcon icon={modalIcon} color="#CCC" style={{ fontSize: 50, marginBottom: 30 }} />
                            </div>
                            <h3>{modalTitle}</h3>                            
                            {placeholderData}                            
                        </div>
                    </Modal.Body>
                </div>
            </Modal >
        </>
}


export default ButtonModalPlaceholder;
